import {
  ActionContainer,
  FormContainer,
  Title,
} from "./InventoryUpdatesStyles";
import React, { SyntheticEvent, useRef, useState } from "react";
import Modal from "../../../common/Modal";
import ModalContentWithCloseButton from "../../../common/ModalContentWithCloseButton";
import Button from "../../../common/Button";
import { ButtonTypes } from "../../../common/Button/constants";
import useTriggerSounds from "../../../../utils/hooks/sounds";
import { useStringInput } from "../../../../utils/hooks/inputs";
import FormLine from "../../../common/FormLine";
import { useCustomAlert } from "../../../../utils/hooks/alerts";

export default function ScanForMatch({
  containerToFind,
  onFound,
}: {
  containerToFind: string;
  onFound: () => void;
}) {
  const customAlert = useCustomAlert();
  const {
    value: barcodeToCheck,
    reset: resetBarcodeToCheck,
    bind: bindBarcodeToCheck,
  } = useStringInput("");
  const { triggerGoodSound, triggerBadSound } = useTriggerSounds();

  const checkBarcode = (event: SyntheticEvent) => {
    event.preventDefault();
    if (barcodeToCheck.trim() == containerToFind) {
      triggerGoodSound();
      customAlert("You found it!", onFound);
    } else {
      triggerBadSound();
      resetBarcodeToCheck();
    }
  };

  return (
    <ActionContainer>
      <Title>Scan barcodes till you hear the positive sound</Title>
      <FormContainer onSubmit={checkBarcode}>
        <div>{containerToFind}</div>
        <FormLine
          name="containerBarcode"
          label="Container barcode"
          placeholder={"Scan code or enter manually"}
          isRequired={true}
          bind={bindBarcodeToCheck}
          autoFocus
        />
        <Button label={"Check"} type={ButtonTypes.SUBMIT} centerText />
      </FormContainer>
    </ActionContainer>
  );
}

export function ScanForMatchAction() {
  const [containerToFind, setContainerToFind] = useState<string | null>(null);
  const findContainerInputRef = useRef<HTMLInputElement>(null);
  const {
    value: containerBarcode,
    reset: resetContainerBarcode,
    bind: bindContainerBarcode,
  } = useStringInput("");
  const { triggerBadSound } = useTriggerSounds();

  const focusOnInput = () => {
    if (findContainerInputRef.current !== null) {
      findContainerInputRef.current.value = "";
      findContainerInputRef.current.focus();
    }
  };

  const closeModal = () => {
    setContainerToFind(null);
    focusOnInput();
    resetContainerBarcode();
  };

  const submitContainerBarcode = (event: SyntheticEvent) => {
    event.preventDefault();
    if (containerBarcode) {
      setContainerToFind(containerBarcode.trim());
    } else {
      triggerBadSound();
    }
  };

  return (
    <>
      <ActionContainer>
        <Title>Scan to find a match</Title>
        <FormContainer onSubmit={submitContainerBarcode}>
          <FormLine
            name="containerBarcode"
            label="Text you want to find"
            placeholder={"Scan text or enter manually"}
            isRequired={true}
            bind={bindContainerBarcode}
            ref={findContainerInputRef}
          />
          <Button label={"Move"} type={ButtonTypes.SUBMIT} centerText />
        </FormContainer>
      </ActionContainer>
      {containerToFind && (
        <Modal isOpen onRequestClose={closeModal}>
          <ModalContentWithCloseButton closeModal={closeModal}>
            <ScanForMatch
              containerToFind={containerToFind}
              onFound={closeModal}
            />
          </ModalContentWithCloseButton>
        </Modal>
      )}
    </>
  );
}
